import { defineManifest } from '@ndrc/app-sdk/manifest';
import { emitsOf } from '@ndrc/app-sdk/events';
import { events } from './events.js';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'mini_sites',
  name: fr.title,
  description: fr.description,
  icon: 'grid',
  color: 'teal',
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'beta',
  category: 'pedagogie',
  workspace: 'none',
  capabilities: ['interactive'],
  migrations: { schema: 'app_mini_sites', dir: 'migrations' },
  permissions: { uses: [], defines: [] },
  entities: { uses: [], owns: [] },
  events: { emits: emitsOf(events), subscribes: [] },
  ui: {
    student: {
      defaultRoute: '/',
      routes: [
        { path: '/', title: fr.title },
        { path: '/play/:activityId', title: fr.title },
      ],
      layout: 'panel',
    },
    teacher: { panel: false, widgets: [], studentInspector: false },
  },
});
